import { render, staticRenderFns } from "./GeneralQuestion.vue?vue&type=template&id=0e301673&scoped=true&"
import script from "./GeneralQuestion.vue?vue&type=script&lang=js&"
export * from "./GeneralQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e301673",
  null
  
)

export default component.exports